import React from 'react'
import styled from '@emotion/styled'
import { MenuItems } from '../../config/menu'
import { Button, Tooltip } from '@ss/meta-core-components'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { authState } from '@state'
import { MenuIcon } from '../../assets/icons/menuIcon'
import { UserIcon } from '../../assets/icons/userIcon'
import { LogoutIcon } from '../../assets/icons/logoutIcon'

/**
 * Componente menu costruito in base al file nella cartella /config/menu.tsx
 * @component
 */
export const Menu: React.FC = () => {
  const navigate = useNavigate()

  const [, setAuthState] = useAtom(authState)

  /**
   * funzione per il logout
   * @function
   */
  const logout = () => {
    setAuthState({ token: undefined })
    navigate('/login')
  }

  return (
    <Container data-cy={'menu'}>
      <IconContainer data-cy={'menu-go-to-home'}>
        <MenuIcon />
      </IconContainer>
      <ItemList>
        {MenuItems.map((i) => (
          <Tooltip
            dataCy={`menu-tooltip-${i.path.substring(1)}`}
            template={<>{i.label}</>}
            direction={'right'}
            key={i.label}
            tooltipWidth={'max-content'}
          >
            <ButtonContainer>
              <Button
                dataCy={`menu-go-to-${i.path.substring(1)}`}
                onClick={() => navigate(i.path)}
              >
                {i.icon}
              </Button>
            </ButtonContainer>
          </Tooltip>
        ))}
      </ItemList>
      <ItemList>
        <Tooltip
          dataCy={`menu-tooltip-logout`}
          template={<>Logout</>}
          direction={'right'}
          key={'logout'}
          tooltipWidth={'max-content'}
        >
          <ButtonContainer>
            <Button dataCy={`menu-logout`} onClick={() => logout()}>
              <LogoutIcon />
            </Button>
          </ButtonContainer>
        </Tooltip>
      </ItemList>
    </Container>
  )
}

//region STYLE
const Container = styled.div`
  padding-top: 25px;
  min-height: 100vh;
  height: 100vh;
  display: grid;
  grid-template-rows: 55px auto max-content;
  gap: 45px;
  z-index: 3000;
  border-right: 1px solid #ffffff;
`

const IconContainer = styled.div`
  place-self: center;
  height: 55px;
`
const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ButtonContainer = styled.div`
  display: grid;
  height: 45px;
  margin-bottom: 30px;
`
//endregion
